import { toast as sonnerToast } from 'sonner';
import { type ToastVariant } from '@/components/ui/toast';

// This is a wrapper around sonner's toast function that mimics the interface of our custom useToast hook
// This allows us to easily switch from our custom toast to sonner without changing all the toast calls

interface ToastProps {
  title?: string;
  description?: string;
  variant?: ToastVariant;
  action?: React.ReactNode;
  id?: string | number; // Add id property to support toast updates
}

function toast(props: ToastProps) {
  const { title, description, variant, action, id } = props;

  // Common options
  const options = {
    id,
    description,
    action,
  };

  // Map our variants to sonner's functions
  switch (variant) {
    case 'destructive':
      return sonnerToast.error(title || '', options);
    case 'warning':
      // Sonner doesn't have a warning variant, so we'll use the default with a custom icon
      return sonnerToast(title || '', options);
    case 'success':
      return sonnerToast.success(title || '', options);
    default:
      return sonnerToast(title || '', options);
  }
}

export function useToast() {
  return {
    toast,
    dismiss: (id?: string) => {
      if (id) {
        sonnerToast.dismiss(id);
      } else {
        sonnerToast.dismiss();
      }
    },
  };
}

export { toast };
